import clsx from "clsx";
import React from "react";
import { createPluggable } from "pluggable-react";
import styles from "./Bubble.module.scss";
import { withRefProp } from "../../../utils/withRefProp";

export type BubbleVariant = "default" | "conclusion";

export interface BubbleProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  variant?: BubbleVariant;
  ref?: React.Ref<HTMLDivElement>;
}

const DefaultBubble = withRefProp((props: BubbleProps) => {
  const { children, className, variant = "default", ref, ...otherProps } = props;

  return (
    <div
      ref={ref}
      className={clsx(styles.bubble, className)}
      data-deci-bubble="true"
      data-variant={variant}
      {...otherProps}
    >
      <fieldset className={styles.fieldset}>
        <span className={styles.content}>{children}</span>
      </fieldset>
    </div>
  );
});

const Bubble = createPluggable<BubbleProps>("deci.bubble", DefaultBubble);

export default Bubble;
